import { createContext } from 'react'

const FormContext = createContext<React.RefObject<HTMLFormElement | null> | undefined | null>(undefined)

export default FormContext
